import { DEFAULT_COMPETITION_TYPE } from '@/common/constant/qz';
import { fetch } from '@/common/js/fetch';
import { serverCourseUrl } from "./api";
import parseParams from "@/common/js/util";


/**
 *@description 获取试卷列表
 */
export function getExamList(competitionType=DEFAULT_COMPETITION_TYPE) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/list?competitionType=${competitionType}`)
}

export function getExamRecordList(examId) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/record/list?examId=${examId}`)
}

/**
/**
 * 开始考试（首次进入考试时调用）
 *
 * @param {Object} params - 参数对象
 * @param {number} params.courseExamId - 试卷ID
 * @param {number} params.roundId - 场次ID
 * @returns {Promise} 请求结果
 */
export function startExam(params) {
  // return Promise.resolve({
  //   code: 200,
  //   "body": {
  //       "rule": {
  //           "id": "RULE_A",
  //           "costTime": 75,
  //           "totalCount": null,
  //           "totalPoint": 120,
  //           "startPoint": 240,
  //           "description": "75分钟 ｜ 总共24 道选择题，总分 120分 ｜ 起始分数为24 分｜ 答错扣1分，不答不扣分",
  //           "intervals": [
  //               {
  //                   "start": 1,
  //                   "end": 8,
  //                   "score": "3",
  //                   "errorScore": 1
  //               },
  //               {
  //                   "start": 9,
  //                   "end": 16,
  //                   "score": "4",
  //                   "errorScore": 1
  //               },
  //               {
  //                   "start": 17,
  //                   "end": 24,
  //                   "score": "5",
  //                   "errorScore": 1
  //               }
  //           ]
  //       },
  //       "question": [
  //           {
  //               "id": 4201360,
  //               "createTime": 1750997768704,
  //               "updateTime": 1750997768704,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2710,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768704,
  //               "endTime": 1750997768704,
  //               "costTime": 0,
  //               "points": -10,
  //               "validationStatus": "WRONG",
  //               "submitPayload": {
  //                   "submitOption": [
  //                       {
  //                           "id": "B",
  //                           "text": "3"
  //                       }
  //                   ]
  //               },
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第1题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/d7bce994-ee6b-46c6-a4fa-b60f6f624cd4\"></p>",
  //                       "audioText": "小帕有6个气球。他送出去4个气球。请问小帕现在还有多少个气球？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>数与数论</p><p><strong>正答率：</strong>95%（100个同学95个答对）</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "2"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "3"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "4"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "5"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "6"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "A"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201361,
  //               "createTime": 1750997768706,
  //               "updateTime": 1750997768706,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2711,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768706,
  //               "endTime": 1750997768706,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第2题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/51db8442-f9b5-4fad-97d3-d3f8f403b127\"></p><p><br></p><p><img src=\"https://ydschool-online.nosdn.127.net/60783060-9c86-43d1-9666-27fa133e9e25\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/94a2dd71cca7467fa35813f9a3cb63ad.mp3",
  //                       "audioText": "请问下面哪个拼图碎片可以补全这个拼图？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>空间几何</p><p><strong>正答率：</strong>90%</p><p><strong>关键方法：</strong>重点要观察鼻子的位置</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "E"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201362,
  //               "createTime": 1750997768708,
  //               "updateTime": 1750997768708,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2712,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768708,
  //               "endTime": 1750997768708,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第3题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/ad31a485-9ca4-4368-8ab6-e728a6611148\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/2539cf0f8d554456984a780a9c2e613c.mp3",
  //                       "audioText": "请问在图中这些形状里有多少个是三角形？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点</strong>：空间几何</p><p><strong>正答率：</strong>90%</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "2"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "3"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "4"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "5"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "6"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "E"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201363,
  //               "createTime": 1750997768710,
  //               "updateTime": 1750997768710,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2713,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768710,
  //               "endTime": 1750997768710,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第4题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/f701161b-14ce-4a62-b517-3cb2a79d9d4e\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/f572df8ac4554316b42ca4fffce436b9.mp3",
  //                       "audioText": "请问图中有多少支铅笔？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>78%</p><p><strong>关键方法：</strong>一支铅笔有笔尖和橡皮两头，只需要数笔尖或者铅笔头其中一种的数量就可以知道有几只铅笔。错误原因多数是因为没有掌握方法，单纯清点导致漏了少了。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "7"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "8"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "9"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "14"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "16"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "B"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201364,
  //               "createTime": 1750997768711,
  //               "updateTime": 1750997768711,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2714,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768711,
  //               "endTime": 1750997768711,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第5题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/ee20ec5d-d733-4988-b639-1b1544a2ac7a\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/6f02f15d989648ba8e2f05604db6c659.mp3",
  //                       "audioText": "5只袋鼠宝宝沿着下方所示的路径跳向它们的妈妈。请问哪条路径最短？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>82%</p><p><strong>关键方法：</strong>横向（横着）大家走的都是一样多，主要看纵向（竖着，包括向上和向下）走的多少。</p><p><img src=\"https://ydschool-online.nosdn.127.net/f9e867d1-39dc-42d2-9533-560b13ae8da8\"></p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "A"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201365,
  //               "createTime": 1750997768713,
  //               "updateTime": 1750997768713,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2715,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768713,
  //               "endTime": 1750997768713,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第6题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/254ee041-99f4-498a-baed-918b102b512e\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/469a4e37556f43458135d0f7a4d9055f.mp3",
  //                       "audioText": "一个大正方形由16个完全相同的小正方形组成。然后移除一些小正方形，形成如图所示的形状，请问移除了多少个小正方形？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>空间几何</p><p><strong>正答率：</strong>95%</p><p><strong>关键方法：</strong>把横线、竖线补全后清点。</p><p><img src=\"https://ydschool-online.nosdn.127.net/912f274b-750c-4a35-a225-d261c10bed48\"></p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "4"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "5"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "6"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "7"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "8"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "C"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201366,
  //               "createTime": 1750997768714,
  //               "updateTime": 1750997768714,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2716,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768714,
  //               "endTime": 1750997768714,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第7题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/1c72dac0-884e-4848-872f-bac7b5f4ff69\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/d9b4305b92374f0a902b3b8ea8bb4c1b.mp3",
  //                       "audioText": "小卡毛衣上的所有纽扣均为如图所示的样式。请问以下哪个纽扣可能是她毛衣上的？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>空间几何</p><p><strong>正答率：</strong>55%（正答率较低的题目，属于<strong><u>易错题</u></strong>）</p><p><strong>关键方法：</strong>理解题目意思，纽扣上的图案排列是不能任意调换位置的，纽扣是圆形可以旋转，所以通过旋转圆形扣子找到一样的图案。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "E"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201367,
  //               "createTime": 1750997768716,
  //               "updateTime": 1750997768716,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2717,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768716,
  //               "endTime": 1750997768716,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "TEXT_CHOICE_QUESTION",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第8题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/981fcef4-a7cd-4c6d-b0e6-8eee1b99f97b\"></p><p><img src=\"https://ydschool-online.nosdn.127.net/9871e508-cb76-4f14-a711-c827a6151f61\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/654f3fe0ad184682852f15389b5be409.mp3",
  //                       "audioText": "小迈的玩具架上没有小狗、没有兔子、也没有乌龟。请问以下哪个架子可能是小迈的？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>95%</p><p><strong>关键方法：</strong>根据题目中的3个没有，逐个排除。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "D"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201368,
  //               "createTime": 1750997768718,
  //               "updateTime": 1750997768718,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2718,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768718,
  //               "endTime": 1750997768718,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_BLANK_FILLING",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第9题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/bbc4f721-75cc-41aa-a49f-884f2356bca2\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/9638b252710341299acd3115d3dc86e4.mp3",
  //                       "audioText": "两根橡皮筋套在一摞18个立方体上。请问有多少个立方体碰到了橡皮筋？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>空间几何</p><p><strong>正答率：</strong>65%（正答率较低，属于<strong><u>较易错</u></strong>的题目）</p><p><strong>关键方法：</strong>理解题目意思，可以采用积木块实际操作演示。橘黄色一圈是8个正方体，红色一圈是6个正方体，两个带子共同接触的有2块正方体。8+6-2=12</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "6"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "8"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "9"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "10"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "12"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "E"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201369,
  //               "createTime": 1750997768719,
  //               "updateTime": 1750997768719,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2719,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768719,
  //               "endTime": 1750997768719,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_BLANK_FILLING",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第10题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/f2f244e6-cf16-46ba-a71f-cc2e256d0d54\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/c3c07c406ce245648027399daabaf61b.mp3",
  //                       "audioText": "地板上铺有正方形瓷砖，瓷砖上面放有4块长方形垫子。请问总共有多少块瓷砖上面有3块垫子？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>空间几何</p><p><strong>正答率：</strong>58%（正答率低，属于<strong><u>易错题</u></strong>）</p><p><strong>关键方法：</strong>理解语言，被3个垫子盖住的方块有几个？因为最下面两个垫子是分开的，不重叠，要3个垫子都压住，就只能下面两个垫子分别和上面黄色、深蓝色垫子重叠。</p><p><img src=\"https://ydschool-online.nosdn.127.net/82fe2e86-0988-49ae-90c4-703c2c01751c\"></p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "0"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "1"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "2"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "3"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "4"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "E"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201370,
  //               "createTime": 1750997768721,
  //               "updateTime": 1750997768721,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2720,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768721,
  //               "endTime": 1750997768721,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_BLANK_FILLING",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第11题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/44e69a11-66e7-4223-9aa3-b017fa879eb2\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/9769df7dfbd745d080116bbc1f81b12d.mp3",
  //                       "audioText": "请问以下哪把钥匙能打开图中的锁？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点</strong>：空间几何</p><p><strong>正答率：</strong>93%</p><p><strong>关键方法：</strong>1、分析三个形状的顺序；2、注意中间三角形，尖朝向正方形，底朝向圆形</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "D"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201371,
  //               "createTime": 1750997768722,
  //               "updateTime": 1750997768722,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2721,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768722,
  //               "endTime": 1750997768722,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_BLANK_FILLING",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第12题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/1c7e91d4-46b9-4446-92b6-dce632bb55f2\"></p><p><img src=\"https://ydschool-online.nosdn.127.net/61c8f974-5ac6-4ece-93c4-f0ac7743d97d\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/d00c4c9e379545e5b3c830efa4171bee.mp3",
  //                       "audioText": "一条狗有2只体重相同的幼崽。第一张图显示，这条狗和1只幼崽的总重量是14千克。第二张图显示，这条狗和2只幼崽的总重量是18千克。请问这条狗多众？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>代数函数</p><p><strong>正答率：</strong>87%</p><p><strong>关键方法：</strong>对比两个图，重量的差异来自一只小狗（幼崽），那么一只小狗中4千克。从第一幅图可以知道大狗重14-4=10千克</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "9千克"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "10千克"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "11千克"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "12千克"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "13千克"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "B"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201372,
  //               "createTime": 1750997768724,
  //               "updateTime": 1750997768724,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2722,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768724,
  //               "endTime": 1750997768724,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_BLANK_FILLING",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第13题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/2634f3f8-af85-490f-830e-ba4b809e317d\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/33db3734034e4ea78e99f224eec7c49f.mp3",
  //                       "audioText": "桌子上原来有12个水果。小维拿走了2个梨、4个苹果和一半的橙子。现在桌子上只剩下橙子。请问桌子上还剩下多少个橙子？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>代数函数</p><p><strong>正答率</strong>：67%（正答率较低，属于<strong><u>较易错题</u></strong>）</p><p><strong>关键方法：</strong>理解题目意思，拿走梨和苹果后，就只有橙子了。梨有2个，苹果有4个，那橙子有12-2-4=6个，一半的橙子就是3个，剩下一半橙子也是3个。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "1"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "2"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "3"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "4"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "6"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "C"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201373,
  //               "createTime": 1750997768726,
  //               "updateTime": 1750997768726,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2723,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768725,
  //               "endTime": 1750997768725,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_BLANK_FILLING",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第14题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/e607eadd-ccd4-435c-95be-aef97bd54539\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/9406dd50891249d1b7c7a411c463c368.mp3",
  //                       "audioText": "12个学生站成一排。从左边开始数，小沃是第5个。从右边开始数，小维是第4个。请问：小沃和小维中间有多少个学生？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>92%</p><p><strong>关键方法：</strong>根据图标注出小沃和小维，然后清点两者中间的人数即可。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "1"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "2"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "3"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "4"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "5"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "C"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201374,
  //               "createTime": 1750997768727,
  //               "updateTime": 1750997768727,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2724,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768727,
  //               "endTime": 1750997768727,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_BLANK_FILLING",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第15题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/12e87a9a-94ba-4ce8-8159-88f950227562\"></p><p><img src=\"https://ydschool-online.nosdn.127.net/25f70428-1d7c-42a7-a0be-63b505689978\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/0d2562f0290f42ff83b69cc11ff7b678.mp3",
  //                       "audioText": "小玛的书架上有三本书，最初的位置如图所示。首先，小玛交换了白色书和灰色书。然后，小玛交换了灰色书和黑色书。请问现在她的书是如何摆放的？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>82%</p><p><strong>关键方法：</strong>可以把书按照从左到右123（白黑灰）标注，第一次交换后变成321，第二次交换后变成231（黑灰白）</p><p><img src=\"https://ydschool-online.nosdn.127.net/f57dda9f-9f68-4cb7-bdb0-885ba5dc40eb\"></p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "D"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201375,
  //               "createTime": 1750997768729,
  //               "updateTime": 1750997768729,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2725,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768729,
  //               "endTime": 1750997768729,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第16题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/4dd1bc3a-09f5-40ab-aeaf-0e479174277b\"></p><p><img src=\"https://ydschool-online.nosdn.127.net/4c7b30a8-70ff-49bd-a3c5-32a8b5063e5c\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/3415c3cdb15143759328fd009af4b333.mp3",
  //                       "audioText": "下图展示了一个由彩色方块搭建的物体的正面和背面。这个物体被分成了三部分。其中两部分如下图所示。请问以下哪个选项是第三部分？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>空间几何</p><p><strong>正答率：</strong>78%</p><p><strong>关键方法：</strong>通过高度对比白色的积木块有2层，第二层只有中间一块，第一层正面反面都可以看到底层边缘的块，说面第一层有3块。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "D"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201376,
  //               "createTime": 1750997768730,
  //               "updateTime": 1750997768730,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2726,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768730,
  //               "endTime": 1750997768730,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第17题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/cf16235b-dff1-490a-92ec-426fe4679dd0\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/0eb2fa3d25304f199bc5b2077535f405.mp3",
  //                       "audioText": "穿在绳子上的主子黑白交替排列，如图所示。每个木块遮住了5颗珠子。请问总共有多少颗白色主子被遮住了？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>80%</p><p><strong>关键方法：</strong>每个遮挡后面是5个珠子，根据规律第一个遮挡：白黑白黑白，第二个遮挡：白黑白黑白，一共是3+3=6个白色珠子</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "5"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "6"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "7"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "9"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "10"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "B"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201377,
  //               "createTime": 1750997768732,
  //               "updateTime": 1750997768732,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2727,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768732,
  //               "endTime": 1750997768732,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第18题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/42859747-fde7-4690-a046-4e0ec1e84227\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/16a4e2149f694a4190c0c678f0e594ae.mp3",
  //                       "audioText": "小安买了3条巧克力棒，小汤买了5条巧克力棒。小汤比小安多付了8欧元。请问一条巧克力棒的价格是多少？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>代数函数</p><p><strong>正答率：</strong>72%</p><p><strong>关键方法：</strong>多付的钱就是多买的巧克力，小汤比小安多买了2个巧克力，多付了8欧元，8欧元就是2个巧克力的价格。那一个巧克力就是4元。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "1欧元"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "2欧元"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "3欧元"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "4欧元"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "5欧元"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "D"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201378,
  //               "createTime": 1750997768733,
  //               "updateTime": 1750997768733,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2728,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768733,
  //               "endTime": 1750997768733,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第19题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/4c4ff370-b95d-48bd-899f-f480c68d37bf\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/84cb2f7c9f8640a59a30d2b279e20a61.mp3",
  //                       "audioText": "三年前，小安和小本的年龄之和是6岁。已知小安现在5岁，请问小本现在多少岁？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>代数函数</p><p><strong>正答率：</strong>55%（正答率低，属于<strong><u>易错题</u></strong>）</p><p><strong>关键方法：</strong>审题仔细。三年前的年龄，小安+小本=6岁；三年后，小安5岁，小本几岁？小安三年前是5-3=2岁，小本三年前是6-2=4岁。那么小本3年后是4+3=7岁。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "1岁"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "5岁"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "6岁"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "7岁"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "11岁"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "D"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201379,
  //               "createTime": 1750997768735,
  //               "updateTime": 1750997768735,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2729,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768735,
  //               "endTime": 1750997768735,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第20题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/e29e3458-3a28-45b2-8d4a-2dd1c72f02dc\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/cbc81b75b612496ca27898ce7ba5512a.mp3",
  //                       "audioText": "小查有5个木制玩具，如图所示。他挑选了两对玩具，使得每对玩具的总重量相同。请问哪个玩具没有被选中。"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>数与数论</p><p><strong>正答率：</strong>72%</p><p><strong>关键方法：</strong>两个重量一样，应该选择较小的和较大的匹配，6+12=18，10+8=18，只有11没有选到。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "D"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201380,
  //               "createTime": 1750997768736,
  //               "updateTime": 1750997768736,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2730,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768736,
  //               "endTime": 1750997768736,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第21题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/73e1bcaf-3e6d-42b4-b3ec-2dd2f277963d\"></p><p><img src=\"https://ydschool-online.nosdn.127.net/0426ae4c-c41c-417d-8021-2e8be6991d76\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/d2de9a6e743942ae8d6238380575b3f0.mp3",
  //                       "audioText": "每个瓢虫贴纸上有1、2、3或者4个点。小艾想用贴纸填满如图所示的网格，使得每行和每列中的瓢虫贴纸上的点数各不相同。请问贴满后网格的顶行是什么样子？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>58%（正答率较低，属于<strong><u>易错题</u></strong>）</p><p><strong>关键方法：</strong>数独题目。可以优先分析第3列或者第4行。</p><p><img src=\"https://ydschool-online.nosdn.127.net/8c7d6814-2037-472a-a04b-f170362d542c\"></p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A"
  //                       },
  //                       {
  //                           "id": "B"
  //                       },
  //                       {
  //                           "id": "C"
  //                       },
  //                       {
  //                           "id": "D"
  //                       },
  //                       {
  //                           "id": "E"
  //                       }
  //                   ],
  //                   "optionType": "EMPTY"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "A"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201381,
  //               "createTime": 1750997768738,
  //               "updateTime": 1750997768738,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2731,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768738,
  //               "endTime": 1750997768738,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第22题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/41301162-7b49-4615-821a-18e289bf7428\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/4267035fb42a47afacd66d43e3a9cbbf.mp3",
  //                       "audioText": "房间的角落里堆着13个立方体。每个立方体都被涂成了红色或者蓝色。已知每个红色立方体的正下方是一个蓝色立方体，每个蓝色立方体的正下方是一个红色立方体。请问在这堆立方体中，蓝色立方体有多少个？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>空间几何</p><p><strong>正答率：</strong>52%（正答率低，属于<strong><u>易错题</u></strong>）</p><p><strong>关键方法：</strong>按照立方体搭建规律将3层图形分开分析</p><p><img src=\"https://ydschool-online.nosdn.127.net/a9bf8f93-b735-40ae-82e3-2dc8f85eb350\"></p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "4"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "6"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "7"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "8"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "9"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "C"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201382,
  //               "createTime": 1750997768739,
  //               "updateTime": 1750997768739,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2732,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768739,
  //               "endTime": 1750997768739,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第23题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/3354563b-8538-4995-86e0-0938bec50c18\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/9184f8583ca04a38ae245fe91bbaf91a.mp3",
  //                       "audioText": "每次往机器里投一枚硬币，就会随机有一个球从底部掉落。请问小巴至少要投多少枚硬币才能确保能拿到一个白球？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>数与数论</p><p><strong>正答率：</strong>19%（正答率极低，<strong><u>困难题</u></strong>）</p><p><strong>关键方法：</strong>理解题目的意思。什么是随机掉落？随机就是不一定从哪里掉出来。什么是确保？就是随机情况下也可以掉出白色。那就需要分析最倒霉的情况。第一个要掉落下来3个球，才到白色球；第二个要掉落下来1个球，才到白色球；第三个要掉落下来2个球，才到白色球；第四个要掉落下来4个球，才到白色球；第5个本身就是白色球。当所有管道下方都是白色球的时候，无论哪个掉下来都是白色。3+1+2+4=10，要掉落10个后，所有管道最下方就都是白色球了。</p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "6"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "10"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "11"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "12"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "15"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "C"
  //                   ]
  //               }
  //           },
  //           {
  //               "id": 4201383,
  //               "createTime": 1750997768741,
  //               "updateTime": 1750997768741,
  //               "status": 0,
  //               "userId": 786760,
  //               "courseExamId": 149,
  //               "courseExamInstanceId": 0,
  //               "courseExamInstanceQuestionId": 2733,
  //               "courseExamRelationId": 173,
  //               "userCourseExamRelationId": 124662,
  //               "userCourseExamRelationInstanceId": 434921,
  //               "startTime": 1750997768741,
  //               "endTime": 1750997768741,
  //               "costTime": 0,
  //               "points": 0,
  //               "validationStatus": "NOTACTIVE",
  //               "submitPayload": {},
  //               "uniqueId": null,
  //               "questionType": "PICTURE_PROOF",
  //               "contentPayload": {
  //                   "title": "【2025】袋鼠A阶第24题",
  //                   "level": "MATH_A",
  //                   "questionStem": {
  //                       "text": "<p><img src=\"https://ydschool-online.nosdn.127.net/9560c348-26c3-4a1f-a080-936ede9b785c\"></p><p><img src=\"https://ydschool-online.nosdn.127.net/9d5134f4-7e1b-447b-99e8-65f92e44b74e\"></p>",
  //                       "audio": "https://nos.netease.com/ydschool-online/b9015a41935e4e1e921e3c118e87b686.mp3",
  //                       "audioText": "小英决定给下图中的每个正方形涂色，使得相同颜色的正方形不相邻。已知她把4个正方形涂成了红色，3个正方形涂成了蓝色，2个正方形涂成了绿色，1个正方形涂成了黄色。请问她把标有X的正方形涂成了什么颜色？"
  //                   },
  //                   "questionAnalysis": "<p><strong>知识点：</strong>逻辑推理</p><p><strong>正答率：</strong>27%（正答率极低，<strong><u>困难题</u></strong>）</p><p><strong>关键方法：</strong>与X可以涂一样颜色的地方还有3个，也就是一共4个地方可以涂同样的颜色。在目前的图形中，其余地方都不能涂出4个同样颜色还满足相同颜色不相邻。红色用了4次，所以X位置涂红色。</p><p><img src=\"https://ydschool-online.nosdn.127.net/989a73de-e880-4a41-9c8a-12a28b491652\"></p>",
  //                   "questionAnalysisVideo": "",
  //                   "options": [
  //                       {
  //                           "id": "A",
  //                           "text": "红色"
  //                       },
  //                       {
  //                           "id": "B",
  //                           "text": "蓝色"
  //                       },
  //                       {
  //                           "id": "C",
  //                           "text": "绿色"
  //                       },
  //                       {
  //                           "id": "D",
  //                           "text": "黄色"
  //                       },
  //                       {
  //                           "id": "E",
  //                           "text": "无法得出答案"
  //                       }
  //                   ],
  //                   "optionType": "TEXT"
  //               },
  //               "renderPayload": {
  //                   "lastStarfireUserName": "cuiyao@corp.netease.com"
  //               },
  //               "validatePayload": {
  //                   "correctOption": [
  //                       "A"
  //                   ]
  //               }
  //           }
  //       ],
  //       "videoUrl": null,
  //       "userExam": {
  //           "examDescription": "说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案说明文案",
  //           "id": 434921,
  //           "createTime": 1750997768697,
  //           "updateTime": 1750997768697,
  //           "status": 0,
  //           "userId": 786760,
  //           "courseExamId": 149,
  //           "courseExamInstanceId": 0,
  //           "courseExamRelationId": 173,
  //           "userCourseExamRelationId": 124662,
  //           "startTime": 1750992930781,
  //           "endTime": 1753228800000,
  //           "totalCostTime": 4837,
  //           "totalPoints": 230,
  //           "totalQuestionCount": 24,
  //           "correctQuestionCount": 0,
  //           "wrongQuestionCount": 1,
  //           "uniqueId": null,
  //           "level": "MATH_A",
  //           "competitionType": "KANGAROO_MATH",
  //           "title": null,
  //           "preview": false
  //       }
  //   }
  // })
  return fetch(`${serverCourseUrl}v1/user/course/exam/start`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
    preview: false,
    ...params,
  }, {
    method: 'POST',
  })
}

export function getExamDetail(id) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/query`, {
    userCourseExamRelationInstanceId: id,
    competitionType: DEFAULT_COMPETITION_TYPE,
  })
}

export function answerExamQuestion(data) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/question/answer`, {
    ...data,
  }, {
    method: 'POST',
  })
}

export function submitExam(id) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/submit?userCourseExamRelationInstanceId=${id}`, {}, {
    method: 'POST',
  })
}

/**
 * 获取所有学校列表
 */
export function getSchoolList() {
//   return Promise.resolve({
//     code:200,
//     body:{
//         "schools": [{
//             "id": 1,
//             "schoolName": "实验中学"
//         },{
//             "id": 2,
//             "schoolName": "实现中学"
//         }]
//     }
// })
  return fetch(`${serverCourseUrl}v1/user/course/exam/school/list`)
}


/**
 * 查询所有考试列表
 */
export function getExamRoundList(params) {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "examRounds": [{
  //       "id": 1, // 考试id
  //       "courseExamId": 1, // 试卷id
  //       "competitionType": "",
  //       "level": "",
  //       "roundName": "考试名",
  //       "order": 12, // 权重
  //       "questionCount": 10,
  //       "startTime": 1757368410000, // 开始时间
  //       "releaseResultTime": 1758232410000, // 释放成绩时间
  //       "rule": {
  //           "id": "RULE_MATHS_TALENTS_3",
  //           "costTime": 180,
  //           "startPoint": 0,
  //           "description": "考试时间180分钟，总分100分。总共13道题：第1-7题（选择题）每道题5分，第8-10题（填空题）每道题5分，第11题 10分，第12-13题 20分，答错/不答不得分",
  //           "totalPoint": 100,
  //           "intervals": [
  //               {
  //                   "start": 1,
  //                   "end": 7,
  //                   "score": 5
  //               }
  //           ]
  //       },
  //       // 考试记录对象（已有的数据结构）
  //       "userCourseExamRelationInstance": {
  //           "id": 11111,
  //           "totalPoints": 110,
  //           "status": 1, // 0未提交 1已提交
  //           markStatus:2
  //           // ...
  //       }
  //   }]
  //   }
  // })
  return fetch(`${serverCourseUrl}v1/user/course/exam/round/list`,{
    ...params,
    competitionType: DEFAULT_COMPETITION_TYPE,
  })
}

/**
 * 检查是否有考试资格
 * @param {Object} params
 * @param {number} params.courseExamId
 * @param {number} params.roundId
 */
export function checkStartExam(params) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/start/check`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
    ...params,
  }, {
    method: 'POST',
  })
}

/*
* @description: 获取考试记录
* **/
export function getExamHistoryList(params) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/user/round/list`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
      ...parseParams(params),
  })
}

export function getExamInfo(params) {
  return fetch(`${serverCourseUrl}v1/user/course/exam/round/query`, {
    competitionType: DEFAULT_COMPETITION_TYPE,
    ...params,
  })
}